class MainProductAdditionalProduct extends HTMLElement {
	constructor() {
		super();

		this.classes = {
			toggleSlider: '.switcher__slider',
			active: 'is-active',
			blockTitle: '.additional-product__block-title',
			showGallery: '.show-gallery',
			additionalImage: '.additional-product__modal-image',
			hidden: 'hidden',
			overFlowHidden: 'overflow-hidden',
			productForm: '.product-form',
		};

		this.elements = {
			toggleSlider: this.querySelector(this.classes.toggleSlider),
			blockTitle: this.querySelector(this.classes.blockTitle),
			showGallery: this.querySelectorAll(this.classes.showGallery),
			additionalImage: this.querySelector(this.classes.additionalImage),
		};

		this.productForm = this.closest(this.classes.productForm)
			? this.closest(this.classes.productForm).querySelector('buy-buttons form')
				? this.closest(this.classes.productForm).querySelector('buy-buttons form')
				: false
			: false;
		this.selectedVariant = {
			id: null,
			title: null,
		};

        if (this.productForm) {
            this.attachListeners();
            this.setSelectedVariant();
        } else {
            this.classList.add(this.classes.hidden);
        }
	}

	attachListeners() {
		this.elements.toggleSlider.addEventListener('click', async (e) => {
			if (e.target.classList.contains(this.classes.active)) {
				e.target.classList.remove(this.classes.active);
				this.elements.blockTitle.classList.remove(this.classes.active);
				this.handleAttribute(false);
			} else {
				e.target.classList.add(this.classes.active);
				this.elements.blockTitle.classList.add(this.classes.active);
				this.handleAttribute(true);
			}
		});

		this.querySelector('custom-select').addEventListener('change', () => {
			this.setSelectedVariant();
		});

		this.elements.showGallery.forEach((button) => {
			button.addEventListener('click', () => {
				this.elements.additionalImage.classList.toggle(this.classes.hidden);
				document.body.classList.toggle(this.classes.overFlowHidden);
			});

			button.querySelector('img').addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
			});
		});
	}

	setSelectedVariant() {
		const selectedInput = this.querySelector('custom-select .custom-select__option[aria-selected="true"]');

		if (selectedInput) {
			this.selectedVariant.id = selectedInput.getAttribute('data-variant-id');
			this.selectedVariant.title = selectedInput.getAttribute('data-value');
		}

		this.displayCorrectPrice();
	}

	handleAttribute(value) {
		this.productForm.querySelector("input[name='properties[Additional Product]']")
			? this.productForm.querySelector("input[name='properties[Additional Product]']").remove()
			: '';

		if (value) {
			const newInput = document.createElement('input');
			newInput.type = 'hidden';
			newInput.name = 'properties[Additional Product]';
			newInput.value = this.selectedVariant.title;
			this.productForm.appendChild(newInput);
			this.productForm.setAttribute('data-additional-product', this.selectedVariant.id);
			this.productForm.setAttribute('data-additional-product-property', this.selectedVariant.title);
			this.productForm.setAttribute('data-additional-product-independent', '');
		} else {
			this.productForm.removeAttribute('data-additional-product', '');
			this.productForm.removeAttribute('data-additional-product-property', '');
			this.productForm.removeAttribute('data-additional-product-independent', '');
		}
	}

	displayCorrectPrice() {
		const priceContainer = this.querySelector('.additional-product__price');
		const allVariantPrices = priceContainer.querySelectorAll('.price__variant');

		allVariantPrices.forEach((price) => {
			if (price.getAttribute('data-variant-id') === this.selectedVariant.id) {
				price.classList.remove(this.classes.hidden);
			} else {
				price.classList.add(this.classes.hidden);
			}
		});
	}
}

if (customElements.get('main-product-additional-product') === undefined) {
	customElements.define('main-product-additional-product', MainProductAdditionalProduct);
}
